/**
 * Checkbox Component - 커스텀 체크박스 (체크 아이콘 SVG: assets/icons/common/check.svg)
 *
 *   <Checkbox checked={v} onChange={(e) => setV(e.target.checked)} label="동의합니다" />
 *   <Checkbox checked={v} onChange={…} />          // 라벨 없이 (카드 등 바깥 <label> 안에 넣을 때)
 *
 * - size: sm(16px) | md(20px, 기본)
 * - 그 외 <input type="checkbox"> 속성(disabled, name 등) 그대로 전달
 * - 스타일: index.css "Checkbox" 섹션
 */

import { InputHTMLAttributes, ReactNode } from 'react';
import CheckIcon from '../../assets/icons/common/check.svg?react';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: ReactNode;
  size?: 'sm' | 'md';
}

export function Checkbox({ label, size = 'md', className = '', ...props }: CheckboxProps) {
  const control = (
    <span className={`checkbox checkbox--${size} ${className}`.trim()}>
      <input type="checkbox" className="checkbox-input" {...props} />
      <span className="checkbox-box" aria-hidden="true">
        <CheckIcon />
      </span>
    </span>
  );

  // 라벨이 있으면 클릭 영역을 라벨까지 넓힘 (바깥에 이미 <label> 이 있으면 label 없이 사용)
  if (!label) return control;
  return (
    <label className="checkbox-label">
      {control}
      <span className="checkbox-text">{label}</span>
    </label>
  );
}

export default Checkbox;
